export default {
    en: {
        JOB_PROGRESS_DIALOG_CONFIRM_TEXT: 'Close',
        JOB_PROGRESS_DIALOG_DEFAULT_LABEL: '{title} Progress'
    }
};
